import React from 'react';
import { Link } from 'react-router-dom';
import type { Lang } from '../offers/config';
const CONTENT = {
  es: {
    label: 'Metodología',
    title: 'El Marco de Decisión de Blinkblis',
    intro: 'Ninguna recomendación aquí sale de una corazonada. Cada una pasa por los mismos cinco pasos, en el mismo orden.',
    steps: [{
      t: 'Investigar',
      d: 'Revisamos el producto, la categoría y la necesidad real del lector.'
    }, {
      t: 'Comparar',
      d: 'Evaluamos alternativas por costo, valor, riesgo y facilidad de acceso.'
    }, {
      t: 'Puntuar',
      d: 'Asignamos un Nivel de Confianza según la calidad de los datos y la claridad de la diferencia.'
    }, {
      t: 'Revisar',
      d: 'Verificamos las afirmaciones, los límites y las desventajas antes de publicar.'
    }, {
      t: 'Recomendar',
      d: 'Explicamos para quién es, y para quién no lo es.'
    }],
    link: 'Ver la metodología completa'
  },
  en: {
    label: 'Methodology',
    title: 'The Blinkblis Decision Framework',
    intro: 'No recommendation here comes from a hunch. Each one goes through the same five steps, in the same order.',
    steps: [{
      t: 'Research',
      d: "We review the product, the category and the reader's actual need."
    }, {
      t: 'Compare',
      d: 'We weigh alternatives on cost, value, risk and accessibility.'
    }, {
      t: 'Score',
      d: 'We assign a Confidence Level based on data quality and how clear the difference is.'
    }, {
      t: 'Review',
      d: 'We verify claims, limits and downsides before publishing.'
    }, {
      t: 'Recommend',
      d: 'We explain who it is for, and who it is not for.'
    }],
    link: 'See the full methodology'
  }
};
export function DecisionFramework({
  lang
}: {
  lang: Lang;
}) {
  const c = CONTENT[lang];
  return <section className="mb-14 rounded-3xl border border-white/10 bg-white/[0.02] p-6 sm:p-8" data-id="element-25" data-mp="2ql6wfolkch7y">
      <span className="text-[12px] uppercase tracking-[0.14em] text-accent" data-id="element-26" data-mp="2qn1fsyh6s19x">
        {c.label}
      </span>
      <h2 className="font-display text-[24px] sm:text-[28px] font-semibold tracking-[-0.02em] mt-3 mb-3" data-id="element-27" data-mp="2zlv7qbjko3h5">
        {c.title}
      </h2>
      <p className="text-[16px] text-white/50 font-light leading-relaxed mb-8 max-w-xl" data-id="element-28" data-mp="2ulqquker56qe">
        {c.intro}
      </p>

      <ol className="relative border-l border-white/10 ml-3" data-id="element-29" data-mp="39ihtd2jq2yk8">
        {c.steps.map((s, i) => <li key={s.t} className="relative pl-7 pb-7 last:pb-0" data-id="element-30" data-mp="34kgbgky195ac" data-mpi={i}>
            <span className="absolute -left-[13px] top-0 w-[26px] h-[26px] rounded-full bg-background border border-accent/40 text-accent text-[12px] font-semibold flex items-center justify-center" data-id="element-31" data-mp="3icmfx9rtpnty">
              {i + 1}
            </span>
            <h3 className="text-white font-medium text-[16px] mb-1" data-id="element-32" data-mp="3satuxn2jxvtb">{s.t}</h3>
            <p className="text-[14px] text-white/50 leading-relaxed font-light" data-id="element-33" data-mp="3ncsc9391fyid">
              {s.d}
            </p>
          </li>)}
      </ol>

      <Link to="/metodologia" className="inline-block mt-7 text-[14px] text-accent hover:underline" data-id="element-34" data-mp="fqy4y9med94s">
        {c.link} →
      </Link>
    </section>;
}